import { useState, useEffect } from "react";

type UseDelayedValueProps<T> = {
  value: T;
  delay?: number;
};

/**
 * A custom hook that returns a value after a given delay. Useful for animating values e.g. in progress bars.
 * @param value - The value to delay.
 * @param delay - The delay in milliseconds.
 * @returns The delayed value.
 */

export const useDelayedValue = <T>({
  value,
  delay = 0,
}: UseDelayedValueProps<T>) => {
  const [delayedValue, setDelayedValue] = useState<T | null>(null);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDelayedValue(value);
    }, delay);

    return () => clearTimeout(timeoutId);
  }, [value, delay]);

  return delayedValue;
};
